import { idempotencyKey } from "./helpers.mjs";
import { triproutesCountries } from "./triproutes-launch.mjs";
import { startTriproutesLaunch } from "./triproutes-quote.mjs";

export function launchAttemptContext(solution, draft, site) {
  const title = solution === "places-routes" ? (draft.mode && draft.mode!=="single" ? draft.name || draft.region : draft.placeName || draft.name) || (draft.places || "").split(/[|\r\n]/)[0] : draft.cityName;
  const country = triproutesCountries(site).find(item => item.code === draft.countryCode)?.name || draft.country || "";
  return { site, title: [...String(title || "").trim()].slice(0, 200).join(""), country };
}

export async function recordRejectedTriproutesLaunch(api, solution, draft, site, error) {
  const attempt = await api.request(`/v1/triproutes/${solution}/launch-attempts`, {
    method: "POST", body: { id: idempotencyKey("launch"), ...launchAttemptContext(solution, draft, site), errorMessage: error.message },
  });
  error.launchAttemptId = attempt.id;
}

export async function startTrackedTriproutesLaunch(options) {
  const { api, solution, body, isCurrent } = options;
  const attempt = await api.request(`/v1/triproutes/${solution}/launch-attempts`, {
    method: "POST", body: { id: idempotencyKey("launch"), ...launchAttemptContext(solution, { ...body, placeName: body.places?.[0]?.name }, body.site) },
  });
  const report = action => api.request(`/v1/triproutes/${solution}/launch-attempts/${encodeURIComponent(attempt.id)}`, { method: "PATCH", body: { action } }).catch(() => {});
  if (!isCurrent()) { await report("cancelled"); return null; }
  try {
    const result = await startTriproutesLaunch({ ...options, attemptId: attempt.id });
    if (!result) await report("cancelled");
    return result;
  } catch (error) {
    error.launchAttemptId = attempt.id;
    if (!error.status) await report("unconfirmed");
    throw error;
  }
}

export function launchAttemptStatus(attempt, now = Date.now()) {
  if (attempt.state === "accepted") return "Задание создано";
  if (attempt.state === "unknown") return "Запуск не подтверждён";
  if (attempt.state === "cancelled") return "Прерван";
  if (attempt.state === "pending") return now - Date.parse(attempt.updatedAt) > 300000 ? (attempt.phase === "dispatch" ? "Запуск не подтверждён" : "Прерван") : "Отправляется";
  return "Не запущен";
}
export function launchAttemptReason(attempt) {
  if (attempt.reason) return attempt.reason;
  if (attempt.state === "accepted") return "Задание создано. Ожидаем запись исполнения.";
  if (attempt.phase === "dispatch") return "Ответ о создании задания ещё не подтверждён.";
  return launchAttemptStatus(attempt) === "Прерван" ? "Отправка прервана до создания задания." : "Проверяются параметры и условия запуска.";
}
export function launchAttemptCost(attempt) { return attempt.phase === "dispatch" || attempt.state === "accepted" ? "—" : "0,00"; }
